// Copyright 2025 LiveKit, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v1.10.1 with parameter "target=dts+js"
// @generated from file livekit_connector_twilio.proto (package livekit, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { RoomAgentDispatch } from "./livekit_agent_dispatch_pb.js";

/**
 * @generated from message livekit.ConnectTwilioCallRequest
 */
export const ConnectTwilioCallRequest = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ConnectTwilioCallRequest",
  () => [
    { no: 1, name: "twilio_call_direction", kind: "enum", T: proto3.getEnumType(ConnectTwilioCallRequest_TwilioCallDirection) },
    { no: 2, name: "room_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "agents", kind: "message", T: RoomAgentDispatch, repeated: true },
    { no: 4, name: "participant_identity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "participant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "participant_metadata", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "participant_attributes", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 8, name: "destination_country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from enum livekit.ConnectTwilioCallRequest.TwilioCallDirection
 */
export const ConnectTwilioCallRequest_TwilioCallDirection = /*@__PURE__*/ proto3.makeEnum(
  "livekit.ConnectTwilioCallRequest.TwilioCallDirection",
  [
    {no: 0, name: "TWILIO_CALL_DIRECTION_INBOUND", localName: "INBOUND"},
    {no: 1, name: "TWILIO_CALL_DIRECTION_OUTBOUND", localName: "OUTBOUND"},
  ],
);

/**
 * @generated from message livekit.ConnectTwilioCallResponse
 */
export const ConnectTwilioCallResponse = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.ConnectTwilioCallResponse",
  () => [
    { no: 1, name: "connect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

